import { getBuilder } from './getBuilder';
import { IAppState } from '../../common/state';

export const getBuilderChatEnabled = (state: IAppState): boolean => {
  const builder = getBuilder(state);

  return Boolean(builder?.chat.isEnabled);
};
